/* eslint-disable no-case-declarations */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Axios from '../../../axios-proas'
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import { EntOwnersSelect, AddOwner, SearchOwner, SelectOwnersHeader, SelectOwnersItem, SelectOwnersItems, SelectOwnersList, ItemLabel, ItemCode, SelectContainer } from './DropDown.styled';
import { useTranslation } from 'react-i18next';
import { BtnIcon, PrimaryBtnOutlineAction, SearchInput, SearchInputContainer, PrimaryBtnOutlineActionModal, SecondaryBtnOutlineActionModal } from "../../../styles/Common";
import MandatoryMarker from '../../UI/MandatoryMarker';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DoneIcon from '@mui/icons-material/Done';
import SearchIcon from '@mui/icons-material/Search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faUser, faDolly, faPersonRays, faUserGear, faCircleInfo, faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';

function DropDownRoles({  listItems, listRoles, addEntitiesUser, IsMulti = true }) {
    const { t } = useTranslation();
    const [showEntityModal, setShowEntityModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState(null)
    const [entities, setEntities] = useState([]);
    const [items, setItems] = useState(listItems)
    const selectRef = useRef();
    const [display, setDisplay] = useState(false)


    useEffect(() => {  

        //let p = listItems?.map((item, index) => { return { libelle: listRoles?.filter((temp) => temp?.roleId == item?.roleId)[0]?.libelle, roleId: item?.roleId } })
        setItems(listItems)
        //if (listItems?.length>0)
        //    listItems?.map((item, index) => UpdateEntity(listRoles, item, true))
        //else
        setEntities(listRoles);
        return () => {
          
        }
    }, [listItems, listRoles])

  
  

    const SelectEntity = (entity) => {          
        let entityIndex = items?.findIndex(row => row === entity.libelle);
                    let selectedTemp = [...items];
                    if (entityIndex < 0)
                        selectedTemp = [...items, entity.libelle];
        setItems(selectedTemp) 
       /* UpdateEntity(entities, entity.libelle,true)   */               
    }

    const deleteItem = (en) => {
     
        let userEntity = [...items]
        let entityIndex = items.findIndex(ent => ent === en.libelle);
        if (entityIndex >= 0) {
            userEntity.splice(entityIndex, 1)
        }
        setItems(userEntity)
       /* UpdateEntity(entities, en.libelle, false)   */ 

      
      
    }
    return (
        <>

            <AddOwner >
                <FontAwesomeIcon icon={faCirclePlus} style={{ color: "#2174b980", fontSize: "1rem" ,paddingTop: "2px" }} onClick={() => setShowEntityModal(!showEntityModal)} />
                {
                    showEntityModal && (
                        <SelectContainer>
                          
                            <SelectOwnersList>
                                <SelectOwnersHeader>
                          
                                </SelectOwnersHeader>
                                <SelectOwnersItems>
                                    {
                                        entities?.length > 0 ? entities.map(entity => (
                                            <SelectOwnersItem key={entity?.roleId} >
                                                <input type='checkbox' disabled={entity.disabled || false} name={entity.roleId} checked={items?.findIndex(row => row === entity.libelle) >= 0} style={{ marginRight: '0.5rem' }}
                                                    onChange={(e) => {
                                                        items?.findIndex(row => row === entity.libelle) >= 0 ? deleteItem(entity) : SelectEntity({ libelle: entity.libelle, roleId: entity.roleId })
                                                    }}
                                                />
                                                <ItemLabel>{ entity?.libelle}</ItemLabel>
                                                <ItemCode>{entity?.code}</ItemCode>
                                            </SelectOwnersItem>
                                        )) : <div style={{ whiteSpace: "nowrap" }}>
                                            {t('mandat:noAgencies', "Aucune donneé à afficher")}
                                        </div>
                                    }
                                </SelectOwnersItems>

                                <div style={{ display: "flex", justifyContent: "center", width: "auto" }}>
                                    <PrimaryBtnOutlineActionModal>
                                        <DoneIcon onClick={e => { addEntitiesUser(items), setShowEntityModal(false) }} />
                                    </PrimaryBtnOutlineActionModal>

                                    <SecondaryBtnOutlineActionModal>
                                        <CloseIcon onClick={e => setShowEntityModal(false)} />
                                    </SecondaryBtnOutlineActionModal>

                                </div>

                            </SelectOwnersList>

                        </SelectContainer>

                    )
                }
            </AddOwner>



        </>
    );
}

export default DropDownRoles;



